export type EnemyKind = 'wanderer' | 'tracker' | 'smarttracker' | 'dodger';

interface EnemyMix {
  wanderer: number;
  tracker: number;
  smarttracker: number;
  dodger: number;
  smartCap: number;     // hard cap on SmartTracker per level
}

const MIX_PER_WORLD: Record<number, EnemyMix> = {
  1:  { wanderer: 1.0, tracker: 0,   smarttracker: 0,   dodger: 0,   smartCap: 0 },
  2:  { wanderer: 0.5, tracker: 0.5, smarttracker: 0,   dodger: 0,   smartCap: 0 },
  3:  { wanderer: 0.3, tracker: 0.7, smarttracker: 0,   dodger: 0,   smartCap: 0 },
  4:  { wanderer: 0.6, tracker: 0.4, smarttracker: 0,   dodger: 0,   smartCap: 0 },
  5:  { wanderer: 0.6, tracker: 0.4, smarttracker: 0,   dodger: 0,   smartCap: 0 },
  6:  { wanderer: 0.5, tracker: 0.5, smarttracker: 0,   dodger: 0,   smartCap: 0 },
  7:  { wanderer: 0.4, tracker: 0.4, smarttracker: 0.2, dodger: 0,   smartCap: 2 },
  8:  { wanderer: 0.3, tracker: 0.3, smarttracker: 0.2, dodger: 0.2, smartCap: 2 },
  9:  { wanderer: 0.3, tracker: 0.3, smarttracker: 0.2, dodger: 0.2, smartCap: 2 },
  10: { wanderer: 0.2, tracker: 0.3, smarttracker: 0.3, dodger: 0.2, smartCap: 2 },
};

export function pickEnemyKinds(world: number, count: number): EnemyKind[] {
  const mix = MIX_PER_WORLD[world] ?? MIX_PER_WORLD[1];
  const pool: EnemyKind[] = [];
  // Build weighted bag
  const bag: Array<[EnemyKind, number]> = [
    ['wanderer',     mix.wanderer],
    ['tracker',      mix.tracker],
    ['smarttracker', mix.smarttracker],
    ['dodger',       mix.dodger],
  ];
  let smartUsed = 0;
  for (let i = 0; i < count; i++) {
    const total = bag.reduce((s, [, w]) => s + w, 0);
    if (total <= 0) { pool.push('wanderer'); continue; }
    let r = Math.random() * total;
    let pick: EnemyKind = 'wanderer';
    for (const [k, w] of bag) {
      r -= w;
      if (r <= 0) { pick = k; break; }
    }
    if (pick === 'smarttracker') {
      if (smartUsed >= mix.smartCap) { pick = 'tracker'; }
      else smartUsed++;
    }
    pool.push(pick);
  }
  return pool;
}
